import { render } from "./MarauderPhotoAlbums.vue?vue&type=template&id=52beddf5"
import script from "./MarauderPhotoAlbums.vue?vue&type=script&lang=ts"
export * from "./MarauderPhotoAlbums.vue?vue&type=script&lang=ts"
script.render = render

export default script